/**
 * Highest id already handed out to a shift option, or 0 when there are none.
 *
 * Callers allocate the next option's id as `latestShiftOptionId(...) + 1`, and a
 * 24/7 site allocates two (`+ 1` and `+ 2`) for the two Open Day halves. A plain
 * `Math.max(...[])` returns -Infinity, and -Infinity + 1 === -Infinity + 2, so
 * those two halves would collide on the same id.
 *
 * The list used to be guaranteed non-empty, because a Custom option was always
 * appended. It can now be empty: a user restricted to open-day bookings has every
 * other shift type filtered out before this point.
 */
const latestShiftOptionId = (ids: Array<number | undefined>): number => {
    const known = ids.filter((id): id is number => id !== undefined);

    return known.length ? Math.max(...known) : 0;
};

export default latestShiftOptionId;
